import React from 'react';
import {Typography, capitalize} from '@mui/material';

import {formatDateWithWeekday} from 'presentation/utils';
import {DateFormatEnum} from 'presentation/constants';
import {DateWithWeekdayProps} from './types';

function DateWithWeekday({date, variant = 'booking'}: DateWithWeekdayProps) {
	if (variant === 'history') {
		const {formatted} = formatDateWithWeekday(date, DateFormatEnum.DATE_FORMAT_2);

		return (
			<Typography variant="body1" fontWeight={600} color="other.subtitle">
				{capitalize(formatted)}
			</Typography>
		);
	}
	return (
		<Typography variant="body1">
			<Typography fontWeight={700} component="span">
				{capitalize(formatDateWithWeekday(date).weekday)}
			</Typography>
			, {formatDateWithWeekday(date).day} de {capitalize(formatDateWithWeekday(date).month)}{' '}
			de {formatDateWithWeekday(date).year}
		</Typography>
	);
}
export {DateWithWeekday};
